const FormErrorType = {
  NULL: '1',
  EQUAL: '2',
  NOT_EQUAL: '3',
  OVER_LENGTH: '4',
  TYPE_ERROR: '5',
  OTHER: '6',
};
const FormType = {
  SAVE_DATA: '0',
  TEXT: '1',
  PASSWORD: '2',
  MONEY: '3',
  TEXT_AREA: '4',
  SELECT: '5',
  RADIO: '6',
  CHECK: '7',
  DATE: '8',
  MULTI_INPUT: '9',
  UPLOAD: '10',
  SEARCH: '11',
  SELECT_DEFINE: '12',
  OTHER: '13',
  CARD: '14',
  NUMBER: '15',
};

export { FormType, FormErrorType };
